import React from 'react';
import {addToken} from '../../store/actions/token';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Button} from '../../components';
import '../../../public/undraw_notes1_cf55.svg'

const Home = ({tokenObject,addToken}) => {
    
    const history = useHistory();

    function handleSignin(){
        history.push('/Signin');
    }

    function handleLogin(){
        history.push('/Login');
    }

    console.log(tokenObject);

    return(
        <>
        <div class="row align-items-center">
            <div class="col">
                <br/>
                    <h1>Biblioteca ADS</h1>
                <br/>
                    
                Essa biblioteca foi criada para armazenar conteúdo dos anos do curso de ADS 2021-2023
                <br/>
                <br/>
                    Made by Gabriel Gomes
                <br/>
                <br/>
                {(() => {
                    if(tokenObject.token !== ""){
                        return(<></>)
                    }else{
                        return(
                            <>
                                <Button type="primary" isOutline="true" onClick={handleSignin}>Criar conta</Button> <></>
                                <Button type="success" isOutline="true" onClick={handleLogin}>Logar no sistema</Button>
                            </>
                        )
                    }  
                })()}
            </div>
            <div class="col">
                <img src="undraw_notes1_cf55.svg" alt="Notes svg" width="500" height="500"/>
            </div>
        </div>
            
        </>
    );
}

const mapStateToProps = (state) => ({
    tokenObject: state.token
});


export default connect(mapStateToProps,{addToken})(Home);